import {
  SET_DEVICES,
  SET_CURRENT_DEVICE,
  SET_DEVICE_COUNT,
  SET_META_DATA,
  SET_NEXT_DEVICE_PAGE,
  ADD_DEVICES,
} from '../../constants';

const initialState = {
  devicesList: [],
  currentDevice: null,
  deviceCount: 0,
  metaData: [],
  metaDataPages: 0,
  nextDevicePage: null,
};

const devicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEVICES:
      return { ...state, devicesList: action.devices };
    case ADD_DEVICES:
      return { ...state, devicesList: [...state.devicesList, ...action.devices] };
    case SET_NEXT_DEVICE_PAGE:
      return { ...state, nextDevicePage: action.url };
    case SET_CURRENT_DEVICE:
      return { ...state, currentDevice: action.device };
    case SET_DEVICE_COUNT:
      return { ...state, deviceCount: action.deviceCount };
    case SET_META_DATA:
      return { ...state, metaData: action.metaData, metaDataPages: action.metaDataPages };
    default:
      return state;
  }
};

export default devicesReducer;
